import { blobToDataUri } from "@passio/api-client";

export interface SamplePhoto {
  id: string;
  label: string;
  src: string;
  /** What the photo is good for showing. */
  note: string;
}

export const SAMPLE_PHOTOS: SamplePhoto[] = [
  { id: "coffee", label: "Black coffee", src: "/samples/black-coffee.jpg", note: "A dark drink in a mug: coffee, or could it be tea or cola?" },
  { id: "salad", label: "Garden salad", src: "/samples/garden-salad.jpg", note: "Green slices that could be cucumber or zucchini." },
];

export const SAMPLE_BARCODES = [
  { code: "818290014474", label: "Chobani yogurt" },
  { code: "049000028911", label: "Diet Coke" },
  { code: "016000275287", label: "Cheerios" },
  { code: "038000138416", label: "Pringles" },
];

/** Fetch a bundled sample photo as the data URI the vision routes take. */
export async function sampleDataUri(src: string): Promise<string> {
  const res = await fetch(src);
  if (!res.ok) throw new Error(`Couldn't load the sample photo (HTTP ${res.status}).`);
  return blobToDataUri(await res.blob());
}
